import axios from "axios";
import ConnectionClient from "../../shared/api-client";

export interface Pagination {
  items: [];
  total: number;
  pageSize: number;
}

export interface Query {
  filter: any;
}

export interface Pagination {
  items: [];
  total: number;
  pageSize: number;
}

export const CapacitiesMapping: any = {
  Productos: "products",
  Proyectos: "projects",
};

export const getCapacitiesType = async () => {
  const entities = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/capacitiesTypes?fields=*.*`
  );
  return entities.data.data;
};

export const getCapacities = async (capacityName: string) => {
  const capacities = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/${CapacitiesMapping[capacityName]}?fields=*.*`
  );
  return capacities.data.data;
};

export const getData = async (collection: string, query: Query) => {
  let q = null;
  if (!query.filter) {
    q = `${process.env.REACT_APP_API_HOST}/items/${collection}?fields=*.*.*&deep=true`;
  } else {
    q = `${process.env.REACT_APP_API_HOST}/items/${collection}?${Object.values(
      query.filter
    ).join("")}&fields=*.*.*&deep=true`;
  }
  const response = await axios.get(q);
  return response.data.data;
};

export const load = async (
  collection: string,
  query: Query,
  page: number = 0,
  limit: number = 10,
  user?: any
) => {
  let result: any = [];
  if (user) {
    const client = new ConnectionClient();
    result = await client.api.get(
      `${
        process.env.REACT_APP_API_HOST
      }/capacities/initial-data?page=${page}&limit=${limit}&${Object.values(
        query.filter
      ).join("")}&fields=*.*.*&deep=true${
        collection ? `&collection=${collection}` : ""
      }`
    );
    return {
      items: result?.data?.data || [],
      meta: result?.data?.meta,
    };
  } else {
    result = await axios.get(
      `${
        process.env.REACT_APP_API_HOST
      }/capacities/initial-data?page=${page}&limit=${limit}&${Object.values(
        query.filter
      ).join("")}&fields=*.*.*&deep=true${
        collection ? `&collection=${collection}` : ""
      }`
    );
    return {
      items: result?.data?.data || [],
      meta: result?.data?.meta,
    };
  }
};

export const recomendations = async (
  collection: string,
  query: Query,
  page: number = 1,
  limit: number = 10
) => {
  const client = new ConnectionClient();
  const result = await client.api.get(
    `${
      process.env.REACT_APP_API_HOST
    }/capacities/recomendations?page=${page}&limit=${limit}&${Object.values(
      query.filter
    ).join("")}&fields=*.*.*&deep=true${
      collection ? `&collection=${collection}` : ""
    }`
  );
  return {
    items: result?.data?.data || [],
    meta: result?.data?.meta,
  };
};
